class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const upsell = this.dataset.upsell;

      if (upsell) {
        cartItems.updateQuantity(this.dataset.index, 0, event);
        return;
      }
      const cart_custom_rules = document.querySelector('.data-cart-rules').dataset;
      const remove_qty = cart_custom_rules.count - cartItems.querySelector('input').value;

      if (cart_custom_rules.upsell == remove_qty) {
        this.clearCart();
        return;
      }

      const boxid = this.dataset.boxid;

      // Normal remove
      if (!boxid) {
        cartItems.updateQuantity(this.dataset.index, 0, event);
        return;
      }

      cartItems.querySelector('.loading__spinner').classList.remove('hidden');

      // Fetch cart
      const cart = await fetch("/cart.js").then(r => r.json());

      // Get all items with same bundle ID
      const items = cart.items.filter(item => item.properties?._bid === boxid);

      if (items.length === 0) return;

      const updates = {};
      items.forEach(item => updates[item.key] = 0);

      // Batch remove
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });

      this.updateCart();
    });
  }

  // ✅ FIXED METHOD — inside class, not standalone
  async clearCart() {
    await fetch('/cart/clear.js', { method: 'POST' });
    this.updateCart();
  }

  // ✅ FIXED METHOD — brackets corrected
  async updateCart() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['.cart-drawer', '.cart-count-bubble'];

        selectors.forEach(selector => {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);

          if (target && source) target.replaceWith(source);
          if (target && !source) target.remove();

          const items = source?.querySelector('cart-drawer-items');
          if (items && items.classList.contains('is-empty')) {
            document.querySelector('cart-drawer')?.classList.add('is-empty');
          }
        });
      });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);
